module.exports = __webpack_public_path__ + "static/media/data.3ab5e4af.jpg";